import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_400: DocMigration = {
  maxSchemaVersion: "0.0.400",
  description: "Eave return generation from roof perimeter rails",
  apply(json: any) {
    const { roofs } = json;

    // roof instances
    for (const roofId in roofs) {
      const roof = roofs[roofId];
      const { flags = {} } = roof;

      // add the new flag
      flags["LEGACY_EAVE_RETURNS"] = true;

      // add the flags set to the roof
      roofs[roofId] = {
        ...roof,
        flags,
      };
    }

    return json;
  },
};

export default migration_0_0_400;
